import {connect} from "react-redux";
import BarcodePasteReaderListenerDialog
    from "../../Components/Orders/BarcodeReaderDialog/BarcodePasteReaderListenerDialog";
import {editOrderAction} from "../actions/ordersActions";
import * as logActions from "../actions/logActions";

const mapStateToProps = (store) => {
    return {
        acceptedOrders: store.ordersReducer.deliveryOrders.filter(order => order.status === "ACCEPTED")
    }
};

const mapDispatchToProps = {
    editOrder: editOrderAction,
    logInfo: logActions.logInfoAction
};

const BarcodePasteReaderListenerDialogContainer = connect(mapStateToProps, mapDispatchToProps)(BarcodePasteReaderListenerDialog);

export default BarcodePasteReaderListenerDialogContainer;